<div class="button-container" [ngClass]="buttonPosition">
  <button 
    (click)="handleLinkClick()"
    mat-flat-button 
    class="button button--large">
    {{ buttonText }}

    <lib-icon icon="caret-right" [size]="18" class="caret-icon"></lib-icon>
  </button>
</div>